module.exports = __webpack_public_path__ + "img/girlAva.72c57252.svg";